import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { servicedeskRovoEntrypoint } from '@jira/spa-apps__project-settings-service-desk-rovo/src/servicedeskRovoEntrypoint.entrypoint.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { featuresResource } from '@jira/router-resources__service-project-features/src/featuresResource.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsServicedeskRovoRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskRovoRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';

const servicedeskRovoPageEntrypoint = createPageEntryPoint({
	main: servicedeskRovoEntrypoint,
});

const getRovoFeatureResources = () => (fg('ai_summary_section') ? [featuresResource] : []);

export const projectSettingsServicedeskRovoRouteEntry: ReturnType<typeof createEntry> = createEntry(
	projectSettingsServicedeskRovoRoute,
	() => ({
		group: 'project-settings-servicedesk',
		ufoName: 'jsm-rovo-settings',
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},
		entryPoint: () =>
			(fg('enable-esa-jsm-ga') || fg('rovo_agent_self_setup_admin_config_enabled')) &&
			fg('enable-rovo-settings-revamp')
				? servicedeskRovoPageEntrypoint
				: notFoundPageEntrypoint,

		resources: [
			...getServiceDeskSettingsResources(),
			...getRovoFeatureResources(),
			getConsolidationStateResource(),
		],
		perfMetricKey: 'jsm-rovo-settings',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
